import http from '@/plugins/axios';

export default {
  saveConfig(data) {
    return http.post('/widget-global-config', data).then(res => res.data);
  },
  getConfig() {
    return http.get('/widget-global-config').then(res => res.data);
  },
  setConfig(params) {
    if (params['type'] === 'badge') {
      return http.post('/plugin-badge-settings', {
        ...params,
      });
    }
    if (params['type'] === 'carousel') {
      return http.post('/plugin-carousel-settings', {
        ...params,
      });
    }
    if (params['type'] === 'stars') {
      return http.post('/plugin-stars-settings', {
        ...params,
      });
    }
    return http.post('/plugin-settings', {
      ...params,
    });
  },
  setDefaultSorting(defaultSorting) {
    return http.post('/plugin-default-sorting', { defaultSorting });
  },
  updateReviewsPerPage(reviewsPerPage) {
    return http.post('/update-reviews-per-page', {
      reviewsPerPage: reviewsPerPage,
    });
  },
  updateWidgets(newWidgetVersion) {
    return http.post('/update-widgets', { newWidgetVersion: newWidgetVersion });
  },
  editRatings(showRatings) {
    return http.post('/edit-show-ratings', { showRatings: showRatings });
  },
  editBranding(showBranding) {
    return http.post('/edit-show-branding', { showBranding: showBranding });
  },
  searchReviews(search) {
    const params = {
      search,
    };
    return http.get('/search-reviews', {
      params,
    });
  },
  installCarousel() {
    return http.post('/install-carousel');
  },
  toggleWidget(params) {
    return http.post('/hide-widgets', {
      ...params,
    });
  },
  getActiveWidgets() {
    return http.get('/hide-widgets');
  },
};
